import { RegisterComponent } from '../../ecs/Component';
import { AmbientLight } from '../../thirdparty/three/imports';
import { Light3D } from './Light3D';

declare module '../../ecs/Component'
{
    interface ComponentMap { AmbientLight3D: AmbientLight3D; }
}

/**
 * 3D环境光，包装`three`中`AmbientLight`
 */
@RegisterComponent({ name: 'AmbientLight3D' })
export class AmbientLight3D extends Light3D
{
    _light: AmbientLight = new AmbientLight();
}
